// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1y85m","subheader":"ReorderModal_subheader__26LA0","listWrap":"ReorderModal_listWrap__3OcBl"};